<section class="flex flex-column consult__section">
  <div class="col-12 inline-flex align-items-center justify-content-between consult__section-subheading-group">
    <h2 class="consult__section-subheading">
      <label for="header_{{turn}}" class="field__label no-margin">{{screen.labels.header.heading}}</label>
    </h2>
    <span class="consult__section-help"></span>
  </div>

  <div class="col-12 px-0 inline-flex flex-wrap col-12" *ngIf="value">
    <div class="col-3 py-0 pl-0">
      <label class="field__label" for="bloodPressure_{{turn}}">{{screen.labels.header.bloodPressure}}</label>
      <span>
        <p-inputMask name="blood-pressure_{{turn}}" [(ngModel)]="value.bloodPressure" mask="999/99?9" class="no-margin"
          [readonly]="readonly" validation></p-inputMask>
      </span>
    </div>

    <div class="col-3 py-0">
      <label for="pulse_{{turn}}">{{screen.labels.header.pulse}}</label>
      <span>
        <input pInputText type="number" name="pulse_{{turn}}" [(ngModel)]="value.pulse" class="no-margin"
          [readonly]="readonly" validation />
      </span>
    </div>

    <div class="col-3 py-0">
      <label for="temperature_{{turn}}">{{screen.labels.header.temperature}}</label>
      <span>
        <input pInputText type="number" name="temperature_{{turn}}" [(ngModel)]="value.temperature" class="no-margin"
          [readonly]="readonly" validation />
      </span>
    </div>

    <div class="col-3 py-0 pr-0">
      <label for="breathingRate_{{turn}}">{{screen.labels.header.breathingRate}}</label>
      <span>
        <input pInputText type="number" name="breathingRate_{{turn}}" [(ngModel)]="value.breathingRate"
          class="no-margin" [readonly]="readonly" validation />
      </span>
    </div>
  </div>
</section>